const Theme = {
  BLUE: 'blue',
  DARK: 'dark',
  WHITE: 'white',
  LIMED_SPRUCE: 'limed-spruce',
  BLACK: 'black',
  YELLOW: 'yellow',
  WHITE_EXTENDED: 'white-extended',
  DARK_EXTENDED: 'dark-extended',
  ALICE_BLUE: 'alice-blue'
};

export { Theme };
//# sourceMappingURL=themeTypes.js.map
